export default "__VITE_ASSET__56b9ad23__"